import { Alert, Button, Col, Form, Input, Modal, Row, Table, Tag } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import moment from 'moment';
import { currencyFormat } from '../../Utils/formatCurrency';
import { useNavigate } from 'react-router-dom';

function ApprovalSettlement() {
    const navigate = useNavigate();
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [btn, setBtn] = useState({ color: "#04AA6D", text: 'Approve', status: 2 });
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [form] = Form.useForm();
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [isAlertVisible, setIsAlertVisible] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');

    // Page title
    const pageTitle = 'Approval Settlement Data';

    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
            render: (id, record, index) => { 
                ++index; 
                return (page.pagination.current - 1) * page.pagination.pageSize + index 
            },
        },
        {
            title: 'Code',
            dataIndex: 'code',
            key: "code",
            render: (text, record) => record.settlement.settlement_code,
        },
        {
            title: 'Title',
            dataIndex: 'title',
            key: "title",
            render: (text, record) => record.settlement.title,
        },
        {
            title: 'User',
            dataIndex: 'user',
            key: "user",
            render: (text, record) => record.settlement.user.name,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: "status",
            render: (text, record) => {
                let statusValue;
                let statusColor;
                if (record.status_approval.status_approval_id === 1) {
                    statusValue = 'Pending';
                    statusColor = 'blue';
                } else if (record.status_approval.status_approval_id === 2) {
                    statusValue = 'Approved';
                    statusColor = 'green';
                } else {
                    statusValue = 'Rejected';
                    statusColor = 'red';
                }
                return (<Tag color={statusColor}>{statusValue}</Tag>);
            }
        },
        {
            title: 'Created At',
            dataIndex: 'created_at',
            key: "created_at",
            render: (text, record) => {
                return record.created_at ? (
                    <p>{moment(record.created_at).format('DD-MM-YYYY HH:mm:ss')}</p>
                ) : "-";
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <>
                    <Button 
                        type="default" 
                        style={{ marginRight: 10 }} 
                        onClick={() => navigate('/detailsettlement', { state: { item: record } })}
                    >
                        <b style={{ marginLeft: 5 }}>View</b>
                    </Button>
                    {record.status_approval.status_approval_id === 1 && (
                        <>
                            <Button 
                                type="primary" 
                                style={{ marginRight: 10, backgroundColor: "#04AA6D" }} 
                                onClick={() => openModal('approve', record)}
                            >
                                <b style={{ marginLeft: 5 }}>Approve</b>
                            </Button>
                            <Button 
                                type="primary" 
                                danger 
                                style={{ marginRight: 10 }} 
                                onClick={() => openModal('reject', record)}
                            >
                                <b style={{ marginLeft: 5 }}>Reject</b>
                            </Button>
                        </>
                    )}
                </>
            ),
        },
    ];

    useEffect(() => {
        fetchData("GET", `/approvalsettlement?search=${search}&page=${page.pagination.current}`, 'approval');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(page), isAlertVisible]);

    const fetchData = (method, url, type) => {
        setLoading(true);
        const dataReq = {
            method: method,
            url: url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setData(res.data.data);
                setPage({
                    ...page,
                    pagination: {
                        ...page.pagination,
                        total: res.data.total_data
                    }
                });
                setLoading(false);
            } else {
                setLoading(false);
            }
        }).catch((e) => {
            setLoading(false);
            console.log(e.message);
        });
    }

    const postData = async (method, url, values) => {
        setLoading(true);
        setIsAlertVisible(false);
        const dataReq = {
            method: method,
            url: url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        await apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setModalData(null);
                setLoading(false);
                setIsAlertVisible(true);
                setAlertMessage(res.message);
                closeModal();
            } else {
                setLoading(false);
                modalError(res.message);
            }
        }).catch((e) => {
            setLoading(false);
            console.log(e.message);
        });
    }

    const confirmDelete = (record) => {
        Modal.confirm({
            title: 'NOTICE',
            content: 'Do you want to delete this data?',
            onOk: () => postData('DELETE', '/approvalsettlement/' + record.approval_settlement_id, null),
        });
    }

    const openModal = (type, data) => {
        switch (type) {
            case 'approve':
                setBtn({ color: "#04AA6D", text: 'Approve', status: 2 });
                setModalData(data);
                setIsModalVisible(true);
                break;
            case 'reject':
                setBtn({ color: "#f44336", text: 'Reject', status: 3 });
                setModalData(data);
                setIsModalVisible(true);
                break;
            default:
                break;
        }
    }

    const onFinish = (values) => {
        const data = {
            "status_approval_id": btn.status,
            "desc": values.desc
        };
        postData("PUT", '/approvalsettlement/' + modalData.approval_settlement_id, data);
    }

    const closeModal = () => {
        setModalData(null);
        setIsModalVisible(false);
        form.resetFields();
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({
            pagination,
            filters,
            ...sorter,
        });
        if (pagination.pageSize !== page.pagination?.pageSize) {
            setData([]);
        }
    };

    const onSearch = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    }

    return (
        <div>
            <Helmet>
                <title>{pageTitle}</title>
            </Helmet>
            {isAlertVisible && (
                <Alert 
                    message={alertMessage} 
                    type="success" 
                    banner 
                    closable 
                    afterClose={() => setIsAlertVisible(false)} 
                />
            )}
            <h3>Approval Settlement</h3>
            <Row>
                <Col span={8}>
                    <Search
                        placeholder="Search"
                        allowClear
                        enterButton="Search"
                        size="middle"
                        onSearch={onSearch}
                    />
                </Col>
                <Col span={16} style={{ display: 'flex', justifyContent: 'flex-end' }} />
            </Row>
            <br />
            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
            />
            <Modal 
                title="Submission" 
                open={isModalVisible} 
                onOk={form.submit} 
                onCancel={closeModal} 
                okText={btn.text} 
                okButtonProps={{ style: { backgroundColor: btn.color } }}
            >
                <Form form={form} name="form" layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        name="desc"
                        label="Description"
                        rules={[
                            {
                                required: false,
                                message: 'Description cannot be empty!'
                            },
                        ]}
                    >
                        <Input.TextArea />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}

export default ApprovalSettlement;
